import * as angular from "angular"
import { IOmniaSession, IUibModalScope } from "../../types"
import { IOmniaUser, RoleId } from "../../user"
import { defineDirective } from "../../utils/angular"
import { IUsersApi } from "../types"

const roleNames = {
    [RoleId.Client]: "Business Manager Client",
    [RoleId.FmClient]: "Field Manager Client",
    [RoleId.ScoutUser]: "Scout User",
    [RoleId.ConnectUser]: "Connect User",
    [RoleId.InvoicingAdmin]: "Invoicing Admin",
    [RoleId.ServiceSpecialist]: "Service Specialist",
    [RoleId.SoilMappingTeam]: "Soil Mapping Team",
    [RoleId.ThirdPartyAgronomist]: "3rd Party Agronomist",
    [RoleId.AccessPlus]: "Access +"
}

/** @internal */
export class EditUserCtrl {

    static create(): ng.IDirective {

        return defineDirective(EditUserCtrl, "shared/user/edit/edit.html", {});

    };

    private $scope: IUibModalScope;

    private form: ng.IFormController;
    private user: IOmniaUser;

    static $inject = ["$scope", "OmniaSession", "OmniaUserApi"];

    constructor($scope: ng.IScope, private session: IOmniaSession, private svc: IUsersApi) {
        this.$scope = <IUibModalScope>$scope.$parent;
        this.user = angular.merge({}, session.currentUser);
    }

    get role(): string {
        const role = this.user.Role
        return roleNames[role] ?? RoleId[role]
    }

    cancelUser() {
        this.user = angular.merge({}, this.session.currentUser);
        this.$scope.$close();
    }

    canSaveUser(): boolean {
        return this.form && this.form.$valid;
    }

    saveUser() {
        this.svc.saveUser(this.user).then((user) => {
            this.session.updateUser(user);
            this.$scope.$close();
        });
    }

    close() {
        this.$scope.$close();
    }
}
